import { BranchLinkOptions } from '../branchLinkConfiguration';
import { UTMParameters } from '@/scripts/libs/initializer/url-parameter-triggers/common-parameters';

export enum BranchFallbackUrlDeviceKey {
  Desktop = '$desktop_url',
  Android = '$android_url',
  IOS = '$ios_url',
}

export const addUTM = (link: string, campaignParameters: Partial<Record<UTMParameters, string>>): string => {
  const url = new URL(link);
  Object.entries(campaignParameters)
    .forEach(([key, value]) => {
      if (!value) return;

      url.searchParams.append(key, value);
    })
  ;
  return url.href;
};

export const generateFallbackUrls = (branchLinkOptions: BranchLinkOptions): Record<BranchFallbackUrlDeviceKey, string> => {
  const campaignParameters = {
    [UTMParameters.Campaign]: branchLinkOptions.campaign,
    [UTMParameters.Medium]: branchLinkOptions.feature,
    [UTMParameters.Source]: branchLinkOptions.channel,
    [UTMParameters.Content]: Array.isArray(branchLinkOptions.tags) ? branchLinkOptions.tags.join(',') : branchLinkOptions.tags,
  };

  const branchLinkOptionsData = {
    [BranchFallbackUrlDeviceKey.Desktop]: location.origin,
    [BranchFallbackUrlDeviceKey.Android]: 'https://play.google.com/store/apps/details?id=com.viddsee',
    [BranchFallbackUrlDeviceKey.IOS]: 'https://itunes.apple.com/app/viddsee-watch-asian-movies/id930821146',
    ...branchLinkOptions.data,
  };

  return {
    [BranchFallbackUrlDeviceKey.Desktop]: addUTM(branchLinkOptionsData[BranchFallbackUrlDeviceKey.Desktop], campaignParameters),
    [BranchFallbackUrlDeviceKey.Android]: addUTM(branchLinkOptionsData[BranchFallbackUrlDeviceKey.Android], campaignParameters),
    [BranchFallbackUrlDeviceKey.IOS]: addUTM(branchLinkOptionsData[BranchFallbackUrlDeviceKey.IOS], campaignParameters),
  };
};

/**
 * Deep clone branch link options and add fallback urls to the options
 * @param branchLinkOptions
 */
export const enrichBranchLinkOptions = (branchLinkOptions: BranchLinkOptions): BranchLinkOptions => {
  // Branch SDK will modify the object that is passed into it. To prevent it
  // from messing with our data. We will do a deep clone of this object
  // first, before passing it to branch sdk
  const clonedBranchLinkOptions = JSON.parse(JSON.stringify({
    ...branchLinkOptions,
    data: {
      ...branchLinkOptions.data,
      ...generateFallbackUrls(branchLinkOptions),
    },
  } as BranchLinkOptions));
  return clonedBranchLinkOptions;
};
